import * as React from 'react';
import {
  FormControlLabel,
  Checkbox,
  FormControl,
  FormGroup,
} from '@material-ui/core';
import type { IStoreDetails } from './StoreInterfaces';

interface StoreDetailsOptionsProps {
  setFormValues: (values: IStoreDetails) => void;
  formValues: IStoreDetails;
}

const StoreDetailsOptions: React.FC<StoreDetailsOptionsProps> = ({ setFormValues, formValues }) => {
  const handleCheckboxChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormValues({ ...formValues, storeOptions: { ...formValues.storeOptions, [event.target.name]: event.target.checked } });
  };

  return (
    <>
      <FormControl component="fieldset" margin="normal">
        <FormGroup>
          <FormControlLabel
            color="primary"
            control={<Checkbox checked={formValues.storeOptions.active} onChange={handleCheckboxChanged} name="active" color="primary" />}
            label="Active"
          />
          <FormControlLabel
            control={<Checkbox checked={formValues.storeOptions.estimatesByEmail} onChange={handleCheckboxChanged} name="estimatesByEmail" color="primary" />}
            label="Estimates by Email"
          />
          <FormControlLabel
            control={<Checkbox checked={formValues.storeOptions.estimatesToCustomer} onChange={handleCheckboxChanged} name="estimatesToCustomer" color="primary" />}
            label="Estimates to Customer"
          />
        </FormGroup>
      </FormControl>
      <FormControl component="fieldset" margin="normal">
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={formValues.storeOptions.mustHaveQC} onChange={handleCheckboxChanged} name="mustHaveQC" color="primary" />}
            label="Must have QC as last assignee"
          />
          <FormControlLabel
            control={<Checkbox checked={formValues.storeOptions.retailerRepairStore} onChange={handleCheckboxChanged} name="retailerRepairStore" color="primary" />}
            label="Retailer Repair Store"
          />
          <FormControlLabel
            control={<Checkbox checked={formValues.storeOptions.labelForRTVs} onChange={handleCheckboxChanged} name="labelForRTVs" color="primary" />}
            label="Create shipping label for RTVs"
          />
        </FormGroup>
      </FormControl>
      <FormControl component="fieldset" margin="normal">
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={formValues.storeOptions.printEstimateWith} onChange={handleCheckboxChanged} name="printEstimateWith" color="primary" />}
            label="Print Estimate with shipping label"
          />
        </FormGroup>
      </FormControl>
    </>
  );
};

export default StoreDetailsOptions;
